/*
 * API Solides
 * \"API de integração com o sistema Solides Gestão. A mesma oferece criação, edição, atualização de registros importantes para sua empresa como: Passaportes, Colaboradores, Ocorrências, Currículos e Vagas.  É obrigatório informar na URL base o parâmetro {locale} cujo os valores possvíeis são: <b>pt-BR</b>, ou <b>es</b>, ou <b>en</b>\"  Para gerar o token de acesso siga os seguintes passos: 1. Acesse https://system.solides.com/pt-BR/usuarios/sign_in e logue com seu usuário. 2. Acesse o sub-menu <b>Configurações</b> 3. Na seção <b>Ativar API de Integração</b>, clique em <b>Ativar API</b>. Isso gerará um token único que deverá ser utilizado em todas as requisições. 4. Configure a Header de sua requisição com essas duas variáveis:     - Content-Type: application/json     - authorization: Token token=<b>[SEU TOKEN]</b> 
 *
 * OpenAPI spec version: 1.0.14
 * Contact: suporte@solides.com.br
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.13
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ApiSolides) {
      root.ApiSolides = {};
    }
    root.ApiSolides.ParametrosDeColaborador = factory(root.ApiSolides.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';

  /**
   * The ParametrosDeColaborador model module.
   * @module model/ParametrosDeColaborador
   * @version 1.0.14
   */

  /**
   * Constructs a new <code>ParametrosDeColaborador</code>.
   * @alias module:model/ParametrosDeColaborador
   * @class
   * @param name {String} nome do colaborador
   * @param email {String} email do colaborador
   * @param cpf {String} CPF do colaborador
   */
  var exports = function(name, email, cpf) {
    this.name = name;
    this.email = email;
    this.cpf = cpf;
  };

  /**
   * Constructs a <code>ParametrosDeColaborador</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ParametrosDeColaborador} obj Optional instance to populate.
   * @return {module:model/ParametrosDeColaborador} The populated <code>ParametrosDeColaborador</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('email'))
        obj.email = ApiClient.convertToType(data['email'], 'String');
      if (data.hasOwnProperty('birthDate'))
        obj.birthDate = ApiClient.convertToType(data['birthDate'], 'Date');
      if (data.hasOwnProperty('gender'))
        obj.gender = ApiClient.convertToType(data['gender'], 'String');
      if (data.hasOwnProperty('maritalStatus'))
        obj.maritalStatus = ApiClient.convertToType(data['maritalStatus'], 'String');
      if (data.hasOwnProperty('education'))
        obj.education = ApiClient.convertToType(data['education'], 'String');
      if (data.hasOwnProperty('nationality'))
        obj.nationality = ApiClient.convertToType(data['nationality'], 'String');
      if (data.hasOwnProperty('birthPlace'))
        obj.birthPlace = ApiClient.convertToType(data['birthPlace'], 'String');
      if (data.hasOwnProperty('fatherName'))
        obj.fatherName = ApiClient.convertToType(data['fatherName'], 'String');
      if (data.hasOwnProperty('motherName'))
        obj.motherName = ApiClient.convertToType(data['motherName'], 'String');
      if (data.hasOwnProperty('zipCode'))
        obj.zipCode = ApiClient.convertToType(data['zipCode'], 'String');
      if (data.hasOwnProperty('neighborhood'))
        obj.neighborhood = ApiClient.convertToType(data['neighborhood'], 'String');
      if (data.hasOwnProperty('city'))
        obj.city = ApiClient.convertToType(data['city'], 'String');
      if (data.hasOwnProperty('stateAcronym'))
        obj.stateAcronym = ApiClient.convertToType(data['stateAcronym'], 'String');
      if (data.hasOwnProperty('number'))
        obj._number = ApiClient.convertToType(data['number'], 'String');
      if (data.hasOwnProperty('additionalInformation'))
        obj.additionalInformation = ApiClient.convertToType(data['additionalInformation'], 'String');
      if (data.hasOwnProperty('phone'))
        obj.phone = ApiClient.convertToType(data['phone'], 'String');
      if (data.hasOwnProperty('cellPhone'))
        obj.cellPhone = ApiClient.convertToType(data['cellPhone'], 'String');
      if (data.hasOwnProperty('emergencyPhoneNumber'))
        obj.emergencyPhoneNumber = ApiClient.convertToType(data['emergencyPhoneNumber'], 'String');
      if (data.hasOwnProperty('personalEmail'))
        obj.personalEmail = ApiClient.convertToType(data['personalEmail'], 'String');
      if (data.hasOwnProperty('corporateEmail'))
        obj.corporateEmail = ApiClient.convertToType(data['corporateEmail'], 'String');
      if (data.hasOwnProperty('departamentId'))
        obj.departamentId = ApiClient.convertToType(data['departamentId'], 'Number');
      if (data.hasOwnProperty('positionId'))
        obj.positionId = ApiClient.convertToType(data['positionId'], 'Number');
      if (data.hasOwnProperty('typeContract'))
        obj.typeContract = ApiClient.convertToType(data['typeContract'], 'String');
      if (data.hasOwnProperty('dateContract'))
        obj.dateContract = ApiClient.convertToType(data['dateContract'], 'String');
      if (data.hasOwnProperty('durationContract'))
        obj.durationContract = ApiClient.convertToType(data['durationContract'], 'String');
      if (data.hasOwnProperty('contractExpirationDate'))
        obj.contractExpirationDate = ApiClient.convertToType(data['contractExpirationDate'], 'Date');
      if (data.hasOwnProperty('registration'))
        obj.registration = ApiClient.convertToType(data['registration'], 'String');
      if (data.hasOwnProperty('salary'))
        obj.salary = ApiClient.convertToType(data['salary'], 'Number');
      if (data.hasOwnProperty('workShift'))
        obj.workShift = ApiClient.convertToType(data['workShift'], 'String');
      if (data.hasOwnProperty('hierarchicalLevel'))
        obj.hierarchicalLevel = ApiClient.convertToType(data['hierarchicalLevel'], 'String');
      if (data.hasOwnProperty('dateAdmission'))
        obj.dateAdmission = ApiClient.convertToType(data['dateAdmission'], 'Date');
      if (data.hasOwnProperty('idNumber'))
        obj.idNumber = ApiClient.convertToType(data['idNumber'], 'String');
      if (data.hasOwnProperty('rg'))
        obj.rg = ApiClient.convertToType(data['rg'], 'String');
      if (data.hasOwnProperty('data_expedicao'))
        obj.dataExpedicao = ApiClient.convertToType(data['data_expedicao'], 'String');
      if (data.hasOwnProperty('orgao_expedidor'))
        obj.orgaoExpedidor = ApiClient.convertToType(data['orgao_expedidor'], 'String');
      if (data.hasOwnProperty('cpf'))
        obj.cpf = ApiClient.convertToType(data['cpf'], 'String');
      if (data.hasOwnProperty('voterRegistration'))
        obj.voterRegistration = ApiClient.convertToType(data['voterRegistration'], 'String');
      if (data.hasOwnProperty('electoralZone'))
        obj.electoralZone = ApiClient.convertToType(data['electoralZone'], 'String');
      if (data.hasOwnProperty('electoralSection'))
        obj.electoralSection = ApiClient.convertToType(data['electoralSection'], 'String');
      if (data.hasOwnProperty('ctpsNum'))
        obj.ctpsNum = ApiClient.convertToType(data['ctpsNum'], 'String');
      if (data.hasOwnProperty('ctpsSerie'))
        obj.ctpsSerie = ApiClient.convertToType(data['ctpsSerie'], 'String');
      if (data.hasOwnProperty('reservist'))
        obj.reservist = ApiClient.convertToType(data['reservist'], 'String');
      if (data.hasOwnProperty('nqc'))
        obj.nqc = ApiClient.convertToType(data['nqc'], 'String');
      if (data.hasOwnProperty('bank'))
        obj.bank = ApiClient.convertToType(data['bank'], 'String');
      if (data.hasOwnProperty('agency'))
        obj.agency = ApiClient.convertToType(data['agency'], 'String');
      if (data.hasOwnProperty('checkingsAccount'))
        obj.checkingsAccount = ApiClient.convertToType(data['checkingsAccount'], 'String');
      if (data.hasOwnProperty('pis'))
        obj.pis = ApiClient.convertToType(data['pis'], 'String');
    }
    return obj;
  }

  /**
   * nome do colaborador
   * @member {String} name
   */
  exports.prototype.name = undefined;

  /**
   * email do colaborador
   * @member {String} email
   */
  exports.prototype.email = undefined;

  /**
   * data de nascimento
   * @member {Date} birthDate
   */
  exports.prototype.birthDate = undefined;

  /**
   * sexo do colaborador
   * @member {module:model/ParametrosDeColaborador.GenderEnum} gender
   */
  exports.prototype.gender = undefined;

  /**
   * estado civil do colaborador
   * @member {module:model/ParametrosDeColaborador.MaritalStatusEnum} maritalStatus
   */
  exports.prototype.maritalStatus = undefined;

  /**
   * escolaridade do colaborador
   * @member {module:model/ParametrosDeColaborador.EducationEnum} education
   */
  exports.prototype.education = undefined;

  /**
   * nacionalidade do colaborador
   * @member {String} nationality
   */
  exports.prototype.nationality = undefined;

  /**
   * naturalidade do colaborador
   * @member {String} birthPlace
   */
  exports.prototype.birthPlace = undefined;

  /**
   * nome do pai
   * @member {String} fatherName
   */
  exports.prototype.fatherName = undefined;

  /**
   * nome da mae
   * @member {String} motherName
   */
  exports.prototype.motherName = undefined;

  /**
   * cep do colaborador
   * @member {String} zipCode
   */
  exports.prototype.zipCode = undefined;

  /**
   * bairro do colaborador
   * @member {String} neighborhood
   */
  exports.prototype.neighborhood = undefined;

  /**
   * cidade do colaborador
   * @member {String} city
   */
  exports.prototype.city = undefined;

  /**
   * estado do colaborador
   * @member {String} stateAcronym
   */
  exports.prototype.stateAcronym = undefined;

  /**
   * número de endereço
   * @member {String} _number
   */
  exports.prototype._number = undefined;

  /**
   * complemento do endereco
   * @member {String} additionalInformation
   */
  exports.prototype.additionalInformation = undefined;

  /**
   * telefone fixo
   * @member {String} phone
   */
  exports.prototype.phone = undefined;

  /**
   * telefone celular
   * @member {String} cellPhone
   */
  exports.prototype.cellPhone = undefined;

  /**
   * número de emergência
   * @member {String} emergencyPhoneNumber
   */
  exports.prototype.emergencyPhoneNumber = undefined;

  /**
   * email pessoal
   * @member {String} personalEmail
   */
  exports.prototype.personalEmail = undefined;

  /**
   * email coorporativo
   * @member {String} corporateEmail
   */
  exports.prototype.corporateEmail = undefined;

  /**
   * identificador do departamento
   * @member {Number} departamentId
   */
  exports.prototype.departamentId = undefined;

  /**
   * identificador do cargo
   * @member {Number} positionId
   */
  exports.prototype.positionId = undefined;

  /**
   * tipo de contrato
   * @member {module:model/ParametrosDeColaborador.TypeContractEnum} typeContract
   */
  exports.prototype.typeContract = undefined;

  /**
   * data de início do contrato
   * @member {String} dateContract
   */
  exports.prototype.dateContract = undefined;

  /**
   * tempo de duração do contrato
   * @member {String} durationContract
   */
  exports.prototype.durationContract = undefined;

  /**
   * data final do contrato
   * @member {Date} contractExpirationDate
   */
  exports.prototype.contractExpirationDate = undefined;

  /**
   * matrícula do colaborador
   * @member {String} registration
   */
  exports.prototype.registration = undefined;

  /**
   * salário do colaborador
   * @member {Number} salary
   */
  exports.prototype.salary = undefined;

  /**
   * turno do colaborador
   * @member {String} workShift
   */
  exports.prototype.workShift = undefined;

  /**
   * nível hierárquico do colaborador
   * @member {module:model/ParametrosDeColaborador.HierarchicalLevelEnum} hierarchicalLevel
   */
  exports.prototype.hierarchicalLevel = undefined;

  /**
   * data de admissão do colaborador
   * @member {Date} dateAdmission
   */
  exports.prototype.dateAdmission = undefined;

  /**
   * cpf do colaboraor
   * @member {String} idNumber
   */
  exports.prototype.idNumber = undefined;

  /**
   * rg do colaborador
   * @member {String} rg
   */
  exports.prototype.rg = undefined;

  /**
   * data de expedição do rg
   * @member {String} dataExpedicao
   */
  exports.prototype.dataExpedicao = undefined;

  /**
   * orgão emissor do rg
   * @member {String} orgaoExpedidor
   */
  exports.prototype.orgaoExpedidor = undefined;

  /**
   * CPF do colaborador
   * @member {String} cpf
   */
  exports.prototype.cpf = undefined;

  /**
   * título de eleitor do colaborador
   * @member {String} voterRegistration
   */
  exports.prototype.voterRegistration = undefined;

  /**
   * zona eleitoral do colaborador
   * @member {String} electoralZone
   */
  exports.prototype.electoralZone = undefined;

  /**
   * seção eleitoral do colaborador
   * @member {String} electoralSection
   */
  exports.prototype.electoralSection = undefined;

  /**
   * ctps num do colaborador
   * @member {String} ctpsNum
   */
  exports.prototype.ctpsNum = undefined;

  /**
   * ctps serie do colaborador
   * @member {String} ctpsSerie
   */
  exports.prototype.ctpsSerie = undefined;

  /**
   * número de reservista do colaborador
   * @member {String} reservist
   */
  exports.prototype.reservist = undefined;

  /**
   * cnh do colaborador
   * @member {String} nqc
   */
  exports.prototype.nqc = undefined;

  /**
   * nome do banco do colaborador
   * @member {String} bank
   */
  exports.prototype.bank = undefined;

  /**
   * número da agência do colaborador
   * @member {String} agency
   */
  exports.prototype.agency = undefined;

  /**
   * conta corrente do colaborador
   * @member {String} checkingsAccount
   */
  exports.prototype.checkingsAccount = undefined;

  /**
   * pis do colaborador
   * @member {String} pis
   */
  exports.prototype.pis = undefined;


  /**
   * Allowed values for the <code>gender</code> property.
   * @enum {String}
   * @readonly
   */
  exports.GenderEnum = {
    /**
     * value: "Feminino"
     * @const
     */
    feminino: "Feminino",

    /**
     * value: "Masculino"
     * @const
     */
    masculino: "Masculino"
  };


  /**
   * Allowed values for the <code>maritalStatus</code> property.
   * @enum {String}
   * @readonly
   */
  exports.MaritalStatusEnum = {
    /**
     * value: "Casado"
     * @const
     */
    casado: "Casado",

    /**
     * value: "Solteiro"
     * @const
     */
    solteiro: "Solteiro",

    /**
     * value: "União Estável"
     * @const
     */
    unioEstvel: "União Estável",

    /**
     * value: "Divorciado"
     * @const
     */
    divorciado: "Divorciado",

    /**
     * value: "Viúvo"
     * @const
     */
    vivo: "Viúvo"
  };


  /**
   * Allowed values for the <code>education</code> property.
   * @enum {String}
   * @readonly
   */
  exports.EducationEnum = {
    /**
     * value: "Curso extra-curricular"
     * @const
     */
    cursoExtraCurricular: "Curso extra-curricular",

    /**
     * value: "Fundamental Incompleto"
     * @const
     */
    fundamentalIncompleto: "Fundamental Incompleto",

    /**
     * value: "Fundamental Completo"
     * @const
     */
    fundamentalCompleto: "Fundamental Completo",

    /**
     * value: "Médio Incompleto"
     * @const
     */
    mdioIncompleto: "Médio Incompleto",

    /**
     * value: "Médio Completo"
     * @const
     */
    mdioCompleto: "Médio Completo",

    /**
     * value: "Superior Incompleto"
     * @const
     */
    superiorIncompleto: "Superior Incompleto",

    /**
     * value: "Superior Completo"
     * @const
     */
    superiorCompleto: "Superior Completo",

    /**
     * value: "Pós Graduação"
     * @const
     */
    psGraduao: "Pós Graduação",

    /**
     * value: "Mestrado"
     * @const
     */
    mestrado: "Mestrado",

    /**
     * value: "Doutorado"
     * @const
     */
    doutorado: "Doutorado"
  };


  /**
   * Allowed values for the <code>typeContract</code> property.
   * @enum {String}
   * @readonly
   */
  exports.TypeContractEnum = {
    /**
     * value: "Efetivos"
     * @const
     */
    efetivos: "Efetivos",

    /**
     * value: "Prestador de Serviço"
     * @const
     */
    prestadorDeServio: "Prestador de Serviço",

    /**
     * value: "Parceiros"
     * @const
     */
    parceiros: "Parceiros",

    /**
     * value: "Contrato"
     * @const
     */
    contrato: "Contrato",

    /**
     * value: "Comissionado"
     * @const
     */
    comissionado: "Comissionado",

    /**
     * value: "CLT + Comissão"
     * @const
     */
    cLTComisso: "CLT + Comissão",

    /**
     * value: "CLT"
     * @const
     */
    CLT: "CLT",

    /**
     * value: "Sócio"
     * @const
     */
    scio: "Sócio",

    /**
     * value: "Estatuários"
     * @const
     */
    estaturios: "Estatuários",

    /**
     * value: "Concursados"
     * @const
     */
    concursados: "Concursados",

    /**
     * value: "Estagiário"
     * @const
     */
    estagirio: "Estagiário",

    /**
     * value: "Cooperado"
     * @const
     */
    cooperado: "Cooperado",

    /**
     * value: "Outros"
     * @const
     */
    outros: "Outros"
  };


  /**
   * Allowed values for the <code>hierarchicalLevel</code> property.
   * @enum {String}
   * @readonly
   */
  exports.HierarchicalLevelEnum = {
    /**
     * value: "Alto"
     * @const
     */
    alto: "Alto",

    /**
     * value: "Baixo"
     * @const
     */
    baixo: "Baixo",

    /**
     * value: "Médio"
     * @const
     */
    mdio: "Médio"
  };

  return exports;

}));
